'use client';

import { useLayoutEffect } from 'react';

/**
 * Custom hook to lock body scroll when active
 * Follows React best practices for cleanup functions
 * @see https://react.dev/learn/synchronizing-with-effects#effects-let-you-synchronize-with-external-systems
 */
export function useBodyScrollLock(isLocked: boolean): void {
  useLayoutEffect(() => {
    if (!isLocked) return;

    // Store original overflow value
    const originalOverflow = document.body.style.overflow;
    document.body.classList.add('overflow-hidden');

    // Cleanup function runs on unmount and before next effect
    return () => {
      document.body.classList.remove('overflow-hidden');
      // Restore original overflow value
      document.body.style.overflow = originalOverflow;
    };
  }, [isLocked]);
}
